<template>
	<div class="breath-call-out" v-loading="loading">
		<section class="breath-call-out__box" v-if="list.length > 0">
			<el-card class="box-card" v-for="(item,index) in list" :key="index">
			  <div slot="header" class="box-card__header">
				 <span class="title">{{item.subject_name}}</span>
			  </div>
			  <div class="box-card__item">
			    <p v-if="item.start_time || item.end_time">{{item.start_time || '不限'}} 至 {{item.end_time || '不限'}}</p>
				<p v-else>不限</p>
				<div>
					<span>剩余:{{item.quota_count}}/{{item.task_count}}</span>
					<el-button type="primary" size="mini" icon="el-icon-phone" @click="onCallout(item)">执行外呼</el-button>
				</div>
			  </div>
			</el-card>
		</section>
		<el-empty description="暂无数据" v-else></el-empty>
	</div>
</template>

<script>
	export default {
		name:'CallOut',
		data() {
			return {
				list: [],
				loading:false
			}
		},
		methods: {
			getList() {
				this.$api.getTaskBreathCalloutList().then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.list = res.data.subjectTaskList;
				}).catch(err => {
					this.loading = false;
				})
			},
			onCallout(row){
				this.$router.push({
					path:`/breathe/callOut/info/${row.subject_id}?type=subject_id`
				})
				
			}
		},
		created(){
			this.loading = true;
			this.getList();
		}
	}
</script>

<style lang="scss" scoped>
	.breath-call-out {
		padding: 10px;
		&__box {
			display: flex;
			flex-wrap: wrap;
		}
		.box-card {
			width: 300px;
			flex-shrink: 1;
			margin: 5px;
			::v-deep .el-card__header {
				padding: 0;
			}
			&__header {
				text-align: center;
				padding: 10px 10px;
				background-color: #337eff;
				color: #fff;
				font-size: 14px;
				
				.title {
					font-weight: bold;
					letter-spacing: 1px;
				}
			}
			&__item {
				font-size: 14px;
				> div {
					margin-top: 10px;
					display: flex;
					justify-content: space-between;
					align-items: center;
				}
				> p {
					font-size: 12px;
				}
			}
		}
	}
</style>
